/**
 * @generated SignedSource<<8e13604afb331d72141e8566a052d58b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoFocusScreen_widgetTodoOverview$data = {
  readonly id: string;
  readonly todoContent: {
    readonly __typename: "WidgetTodoOverviewContentMedium";
  } | {
    readonly __typename: "WidgetTodoOverviewContentMediumGrouped";
    readonly subjectGroups: ReadonlyArray<{
      readonly todos: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"TodoDetailContent_todo">;
      }>;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentSpreads": FragmentRefs<"TodoFocusScreenListHeader_widgetTodoOverview" | "WidgetTodoOverviewContentMediumPaginated">;
  readonly " $fragmentType": "TodoFocusScreen_widgetTodoOverview";
};
export type TodoFocusScreen_widgetTodoOverview$key = {
  readonly " $data"?: TodoFocusScreen_widgetTodoOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoFocusScreen_widgetTodoOverview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoFocusScreen_widgetTodoOverview",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoFocusScreenListHeader_widgetTodoOverview"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTodoOverviewContentMediumPaginated"
    },
    {
      "alias": "todoContent",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TodoSubjectGroup",
              "kind": "LinkedField",
              "name": "subjectGroups",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Todo",
                  "kind": "LinkedField",
                  "name": "todos",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "TodoDetailContent_todo"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "WidgetTodoOverviewContentMediumGrouped",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/)
          ],
          "type": "WidgetTodoOverviewContentMedium",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};
})();

(node as any).hash = "64f8cd35de564cc537e05b90243469a3";

export default node;
